import { render } from "./orderTrackModel.vue?vue&type=template&id=dafcc30a"
import script from "./orderTrackModel.vue?vue&type=script&lang=js"
export * from "./orderTrackModel.vue?vue&type=script&lang=js"

import "./orderTrackModel.vue?vue&type=style&index=0&id=dafcc30a&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__